import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';


const ProvinceCityIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const [List, setList] = useState([]);
    const [ProvinceId, setProvinceId] = useState(0);
    const [Id, setId] = useState(0);
    const [Title, setTitle] = useState('');
    const [ProvinceTitle, setProvinceTitle] = useState('');
    const [WebIsActive, setWebIsActive] = useState(true);
    const [IsDefualt, setIsDefualt] = useState(true);
    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion



    //#region Methods

    const GetAll = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/ProvinceCity/GetByProvinceId', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'IsDeleted': 0
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: result[i].row,
                            id: result[i].id,
                            title: result[i].title,
                            provinceId: result[i].provinceId,
                            isDefualt: result[i].isDefualt,
                            webIsActive: result[i].webIsActive,
                            children: result[i].children,

                        })
                    }
                    setList(tmp)
                })
        )
    }




    const Reset = () => {
        setTitle("");
        setId(0);
        setProvinceId(0);
        setWebIsActive(true);
        setIsDefualt(false)
        setProvinceTitle("");
    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": Id,
                "Title": Title,
                "ProvinceId": ProvinceId,
                "WebIsActive": WebIsActive ? 1 : 0,
                "IsDefualt": IsDefualt ? 1 : 0,
            },
            url: General.ApiRoute() + "/ProvinceCity/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        GetAll();
                        Reset();
                        setShowModal(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(3, id, title);
    }

    const ShowEdit = (Id) => {
        Reset();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/ProvinceCity/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setTitle(result.title);
                    setProvinceId(result.provinceId);
                    setProvinceTitle(result.provinceTitle)
                    setWebIsActive(result.webIsActive == 0 ? false : true);
                    setIsDefualt(result.isDefualt == 0 ? false : true);
                })
        )
    }

    const ShowNew = (provinceId, provinceTitle) => {
        Reset();
        setShowModal(true);
        setProvinceId(provinceId);
        setProvinceTitle(provinceTitle)
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 3);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetAll();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }



    useEffect(() => {
        CheckPermission();
        document.title = "تعریف استان/ شهر ";
    }, [])
    //#endregion







    return (

        <Layout title="استان/شهر">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={() => ShowNew(0, "")}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    isTree
                                    rowKey='id'
                                    height={List.length>20 ? List.length*50 : 560}
                                    data={List}

                                    loading={loading}


                                >
                                    <rsuite.Table.Column className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText className="w-100p" sortable resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="title" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column  width={150} sortable resizable>
                                        <rsuite.Table.HeaderCell>فعال در وب </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.webIsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>

                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column  width={150} sortable resizable>
                                        <rsuite.Table.HeaderCell>پیش فرض نمایش   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.isDefualt == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>

                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>




                                    <rsuite.Table.Column fixed="right" width={60}   >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart"  trigger= {(["contextMenu", 'click'])} speaker={
                                                        <rsuite.Popover full className='PopoverMenu' >
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.children == null || rowData.children.length == 0 ? '' : "hide"} onClick={() => ShowDelete(rowData.id, rowData.title)}>حذف</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.provinceId != 0 ? 'hide' : ""} onClick={() => ShowNew(rowData.id, rowData.title)}>تعریف شهر</rsuite.Dropdown.Item>


                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="md" backdrop="static" keyboard={false} >
                <Modal.Header >

                    <Modal.Title className='fs-5'>{ProvinceId == 0 ? <b>تعریف استان</b> : <b>تعریف شهرهای استان :  {ProvinceTitle}</b>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>


                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setWebIsActive(checked)} checked={WebIsActive} value={WebIsActive} /> &nbsp;  در وب سایت فعال می باشد

                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsDefualt(checked)} checked={IsDefualt} value={IsDefualt} /> &nbsp;  پیش فرض نمایش می باشد

                            </rsuite.Col>


                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>




            <Delete ref={DeleteRef} onSubmit={GetAll} />
        </Layout >


    )
}

export default ProvinceCityIndex;